<template>
  <q-layout view="lHh Lpr lFf">
    <LazyMotion :features="loadMotionFeatures">
      <div
        class="flex w-full min-h-screen relative"
        :class="
          impersonatedUser
            ? 'sticky border-8 border-blue-600 box-border bg-transparent w-screen h-screen z-60'
            : ''
        "
      >
        <ImpersonateBanner v-if="impersonatedUser" />
        <div class="flex flex-col h-full w-full">
          <div
            class="inline-flex w-full relative h-screen"
          >
            <!-- SIDEBAR -->
            <SidebarNavigation />
            <!-- MAIN CONTENT -->
            <main
              class="flex-grow bg-white min-w-[0] overflow-x-hidden relative min-h-full"
            >
              <q-page-container class="h-full w-full">
                <RouterView v-slot="{ Component }">
                  <transition name="fade" mode="out-in" :duration="150">
                    <component
                      :is="Component"
                      :key="route.path"
                      class="bg-neutral-surface-subtle !min-h-full"
                    />
                  </transition>
                </RouterView>
              </q-page-container>
            </main>
          </div>
        </div>
      </div>
    </LazyMotion>
  </q-layout>
</template>
<script setup lang="ts">
import SidebarNavigation from './sidebar/SidebarNavigation.vue';
import ImpersonateBanner from 'src/core/components/layouts/ImpersonateBanner.vue';
import { RouterView, useRoute } from 'vue-router';
import { useUserStore } from 'src/core/stores/user';
import { LazyMotion, loadMotionFeatures } from 'src/core/composables/useMotion';

const userStore = useUserStore();
const impersonatedUser = userStore.user?.impersonated_by;

const route = useRoute();
</script>
